export default "__VITE_ASSET__NvXih4hi__"